export const enTranslations = {
  hello: 'Hello!',
  alMuftiGreet: 'Welcome to the Ministry of Awqaf and Islamic Affairs - Kuwait',
  alMuftiIntro:
    "My name is AlMufti, the Smart Mufti, and I am part of a team of senior scholars and experts in the fields of Sharia and Fatwa. I am here to assist you with your inquiries, provide accurate and reliable religious fatwas, and guide you in utilizing all the services available on the Ministry's official website.",
  talk: 'Start Talking',
  startTyping: 'Start Typing...',
  en: 'English',
  ar: 'AR',
  connecting: 'Connecting',
  tapMic: 'Tap on the mic to speak',
  poweredBy: 'Powered By',
  alMufti: 'Al Mufti',
  askByVoice: 'Ask by Voice',
  askByText: 'Ask by Text',
  backToChat: 'Back To Chat',
  backToHome: 'Back To Home',
  talkTo: 'Talk to ',
  loading: 'Loading...',
  back: 'Back',
  thinking: 'Thinking...',
  reviewing: 'Reviewing...',
  researching: 'Researching...',
  talking: 'Speaking...',
  alMuftiTalking: 'Speaking...',
  alMuftiListening: 'Listening...',
  tapToTalk: 'Tap to Talk',
  tapToPause: 'Tap to Pause',
};
